import types from './types';
import { DEVICE_TYPE_MOBILE } from '../../../general/js/app';

const INITIAL_STATE = {
    isEventsShown: false,
    deviceType: DEVICE_TYPE_MOBILE,
    previewPlayers: [],
    totalPlayersCount: 0,
    events: []
};

export default (state = INITIAL_STATE, action) => {
    // initializing the state by margin default with preloaded state
    if (!state.hydrated) {
        state = { ...INITIAL_STATE, ...state, hydrated: true };
    }

    switch (action.type) {
        case types.SHOW_PREVIOUS_EVENTS: {
            return {
                ...state,
                isEventsShown: true
            };
        }
        case types.CHANGE_DEVICE_TYPE:
            return {
                ...state,
                deviceType: action.deviceType
            };

        default:
            return state;
    }
};
